import { RecoverForm } from "@/components/auth/recover-form.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/auth/recover")({
	component: RecoverComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.auth_recover_title()) }],
	}),
});

function RecoverComponent() {
	return <RecoverForm />;
}
